import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../../components/inputs/input/input";
import ZigZagCredentialsStore from '../../../../stores/credentials/shipping/zigzag-credentials-store';

interface IProps {
    credentialsStore: ZigZagCredentialsStore,
    vGroup: IValidationGroup,
}

const ZigZagCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='ZigZag Username'
                key='username'
                note='Your ZigZag Username'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='ZigZag Password'
                key='password'
                note='Your ZigZag Password'
            >
                <Input
                    value={credentialsStore.password}
                    onChange={credentialsStore.setPassword}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='ZigZag Account Number'
                key='account_number'
                note='Your ZigZag Account Number'
            >
                <Input
                    value={credentialsStore.accountNumber}
                    onChange={credentialsStore.setAccountNumber}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default ZigZagCredentials;
